import SsoErrorPage from './SsoErrorPage';

export default SsoErrorPage;
